// #region Interfaces
// #endregion
export default class RoutingHelper {
    // #region Info
    getRouteInfo(url, target = '') {
        // #region Check
        if (!url) {
            return {
                mode: '',
                address: '',
            };
        }
        // #endregion
        // #region Link
        let tLink = url.toLowerCase();
        let tMode = '';
        let tAddress = '';
        //App => app://
        if (tLink.startsWith("app://")) {
            //Link
            tMode = 'app';
            tAddress = url.substr(6);
            //Optimize
            if (!tAddress.startsWith('/')) {
                tAddress = '/' + tAddress;
            }
        }
        //App => to://
        else if (tLink.startsWith("to://")) {
            //Link
            tMode = 'app';
            tAddress = url.substr(5);
            //Optimize
            if (!tAddress.startsWith('/')) {
                tAddress = '/' + tAddress;
            }
        }
        //App => action://
        else if (tLink.startsWith("action://")) {
            tMode = 'action';
            tAddress = url.substr(9);
        }
        else {
            tMode = 'link';
            tAddress = url;
        }
        // #endregion
        // #region Modal
        if (target === 'modal' && tMode === 'app') {
            tMode = 'app-modal';
        }
        // #endregion
        return {
            mode: tMode,
            address: tAddress
        };
    }
    // #endregion
    // #region Active
    isActive(currentRoute, routeToCheck) {
        // #region Check
        if (!currentRoute || currentRoute === '/') {
            return false;
        }
        if (!routeToCheck || routeToCheck === '/') {
            return false;
        }
        // #endregion
        return currentRoute.toLowerCase().startsWith(routeToCheck.toLowerCase());
    }
    hasActiveChildRoute(currentRoute, node, commandFunc, childrenMember = 'children') {
        // #region Check
        if (!node || !node[childrenMember]) {
            return false;
        }
        if (!node[childrenMember] || node[childrenMember].lenght === 0) {
            return false;
        }
        // #endregion
        // #region Run
        for (var child of node[childrenMember]) {
            //Vars
            let tAddress = commandFunc(child);
            //Children
            if (!tAddress) {
                if (this.hasActiveChildRoute(currentRoute, child, commandFunc, childrenMember)) {
                    return true;
                }
            }
            //Self
            else {
                let tInfo = utils.routing.getRouteInfo(tAddress);
                {
                    if (tInfo.mode === 'app' && utils.routing.isActive(tInfo.address, currentRoute)) {
                        return true;
                    }
                    ;
                }
            }
        }
        // #endregion
        return false;
    }
    setNodesExpanedIfHasActiveRoute(currentRoute, nodes, commandFunc, childrenMember = 'children', expanededMember = 'isExpanded') {
        nodes.forEach(tNode2 => {
            //Run
            if (tNode2[childrenMember] && tNode2[childrenMember].length > 0) {
                this.setNodesExpanedIfHasActiveRoute(currentRoute, tNode2[childrenMember], commandFunc, childrenMember, expanededMember);
            }
            //Set
            if (this.hasActiveChildRoute(currentRoute, tNode2, commandFunc, childrenMember)) {
                tNode2[expanededMember] = true;
            }
        });
    }
}
